(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = (root) => {
      const el = root.querySelector ? root.querySelector('[data-motion~="announce"]') : null;
      if (!el || el._t) return;
      const msgs = el.querySelectorAll('.announcement__msg');
      if (msgs.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      el._t = setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
    };
    document.addEventListener('DOMContentLoaded', () => run(document));
    document.addEventListener('shopify:section:load', (e) => run(e.target));
    document.addEventListener('shopify:section:unload', (e) => { const el = e.target.querySelector('[data-motion~="announce"]'); el && clearInterval(el._t); });
  })();

  } catch(e) { console.error(e); }
})();
})();
